//import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'
import scrollLock from '../../utils/scroll-lock'

class ToggleElement {
  constructor(element) {
    this.element = element
    this.target = element.getAttribute('data-target')
    this.classes = element.getAttribute('data-classes')
    this.siblingsClass = element.getAttribute('data-siblings')

    const targetDomEl = document.querySelector(this.target)

    this.scrollBehabviour = element.getAttribute('data-scroll')

    this.element.addEventListener('click', (event) => {
      let elementAriaExpanded = (this.element.getAttribute('aria-expanded') === 'true')

      event.preventDefault()

      const siblings = [].slice.call(document.querySelectorAll(this.siblingsClass))

      if ( elementAriaExpanded ) {
        scrollLock.disable()

        siblings.forEach(item => item.setAttribute('aria-expanded', 'false'))
        //document.body.style.removeProperty('overflow');

        /*if (!this.scrollBehabviour) {
          clearAllBodyScrollLocks()
        } else {
          clearAllBodyScrollLocks()
        }*/

      } else {
        siblings.forEach(item => item.setAttribute('aria-expanded', 'true'))
        //document.body.style.overflow = 'hidden';
        scrollLock.enable()

      /*  if (!this.scrollBehabviour) {

          disableBodyScroll(document.querySelector('.nav-wrapper'))
        } else {
          disableBodyScroll(targetDomEl)
        }*/
      }

      targetDomEl.classList.toggle(this.classes)


    }, false)

  }
}

export default ToggleElement
